import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { initialize } from "./apis/init_api";
import { B2C_URL } from "./credentials";
import { loginWithAuthtoken } from "./store/user/user-action";
import { setLoginUser } from "./store/user/user-reducer";
import { checkImageSrc } from "./utils/common-utils";

import Favicon from "react-favicon";
import App from "./App";
import Loader from "./components/shared/loader/loader";

const Init = (): JSX.Element => {
  const [initialized, setInitialized] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    initialize()
      .then(async () => {
        const url = window.location.href;
        if (url.indexOf("secure-urls") > -1) {
          const surl = url.substring(url.lastIndexOf("/") + 1);
          const b2cURL = B2C_URL();
          const baseUrl = b2cURL.split("graphql")[0] + "secure-urls/" + surl;
          const res = await axios.get(baseUrl);
          const data = await res.data.data;
          const init_data = JSON.parse(localStorage.getItem("init") || "{}");
          localStorage.setItem("auth_app_id", init_data.auth_app_id);
          init_data.auth_app_id = init_data.auth_app_id_sso;
          localStorage.setItem("init", JSON.stringify(init_data));
          // need to implement landing page implementation here
          localStorage.setItem("landingPage", data.landing_page);
          const auth_token = data.auth_token;
          loginWithAuthtoken(auth_token).then((response) => {
            dispatch(setLoginUser(response));
            setInitialized(true);
          });
        } else {
          setInitialized(true);
        }
      })
      .catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!initialized) {
    return <Loader />;
  }

  return (
    <>
      {" "}
      <Favicon url={checkImageSrc("brandFavicon")} />
      <App />{" "}
    </>
  );
};

export default Init;
